export default __webpack_public_path__ + "static/media/logo_monocromatico_apaizado.1040f607.png";